var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-range-quick"},_vm._l((_vm.resolvedPresets),function(item){return _c('el-button',{key:item.key,attrs:{"size":"small","type":_vm.activeKey === item.key ? 'primary' : 'default',"plain":""},on:{"click":function($event){return _vm.pick(item)}}},[_vm._v(_vm._s(item.label))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }